/*
 * SPDX-FileCopyrightText: 2023 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

export * from './product-details-page.module';
export { PRODUCT_DETAILS_URL_MATCHER } from './product-details-url-matcher';
